<template>
  <div class="fixed inset-0 overflow-hidden z-30" v-show="showSlide">
    <div class="absolute inset-0 overflow-hidden">
      <transition
        enter-active-class="transition-all duration-500 ease-out"
        leave-active-class="transition-all duration-500 ease-in-out"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
        @before-leave="backdropLeaving = true"
        @after-leave="backdropLeaving = false"
      >
        <div v-show="showBackdrop">
          <div class="absolute inset-0 bg-gray-900 opacity-50" @click="close" />
        </div>
      </transition>
      <section class="absolute inset-y-0 right-0 pl-10 max-w-full flex">
        <transition
          enter-active-class="transform transition ease-in-out duration-500"
          leave-active-class="transform transition ease-in-out duration-500"
          enter-class="translate-x-full"
          enter-to-class="translate-x-0"
          leave-class="translate-x-0"
          leave-to-class="translate-x-full"
          @before-leave="cardLeaving = true"
          @after-leave="cardLeaving = false"
        >
          <div v-show="showContent" class="relative w-screen max-w-lg">
            <transition
              enter-active-class="ease-in-out duration-500"
              leave-active-class="ease-in-out duration-500"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
              @before-leave="backdropLeaving = true"
              @after-leave="backdropLeaving = false"
            >
              <div v-show="showBackdrop" class="absolute top-0 left-0 -ml-8 pt-4 pr-2 flex sm:-ml-10 sm:pr-4">
                <button
                  @click.prevent="close"
                  aria-label="Cerrar panel"
                  class="text-gray-300 hover:text-white transition ease-in-out duration-150"
                >
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </transition>
            <div class="h-full flex flex-col bg-white shadow-xl">
              <header class="p-4 bg-primario">
                <h2 class="text-lg leading-7 font-medium text-gray-100">
                  {{ $t("lang.msg.notesExt") }}
                </h2>
              </header>
              <div class="relative flex-1 overflow-y-scroll">
                <!-- ========================= -->
                <!-- === SLOT CONTENT HERE === -->
                <!-- ========================= -->
                <slot />
              </div>
            </div>
          </div>
        </transition>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "SlideOver",
  emits: ['close'],
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSlide: false,
      showBackdrop: false,
      showContent: false,
      backdropLeaving: false,
      cardLeaving: false
    };
  },
  computed: {
    leaving() {
      return this.backdropLeaving || this.cardLeaving;
    }
  },
  watch: {
    open: {
      handler: function (newValue) {
        if (newValue) {
          this.show();
        } else {
          this.close();
        }
      },
      immediate: true
    },
    leaving(newValue) {
      if (newValue === false) {
        this.showSlide = false;
        this.$emit("close");
      }
    }
  },
  methods: {
    show() {
      this.showSlide = true;
      this.showBackdrop = true;
      this.showContent = true;
    },
    close() {
      this.showBackdrop = false;
      this.showContent = false;
    }
  }
};
</script>
